import React, { useEffect, useState } from "react";
import { Card, Alert, Spin } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";

export default function ClosingQuestionnaireReadOnly({ tranId }) {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const authHeaders = { Authorization: `Bearer ${token}` };

  const [loading, setLoading] = useState(true);
  const [answerDoc, setAnswerDoc] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!tranId) return;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/genericAnswer/individual/${tranId}`,
          { headers: authHeaders }
        );
        // Expect shape: { status, data: { answer: { answer: [ {uuid, question, answer}, ... ] } } }
        const doc = res?.data?.data?.answer || null;
        setAnswerDoc(doc);
      } catch (e) {
        setError(e?.response?.data?.message || "Unable to load closing questionnaire.");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tranId]);

  if (loading) return <Spin />;

  if (error) return <Alert type="warning" showIcon message={error} />;

  if (!answerDoc?.answer || !Array.isArray(answerDoc.answer) || answerDoc.answer.length === 0) {
    return <Alert type="info" showIcon message="No closing questionnaire found for this work order." />;
  }

  return (
    <Card
      title="Closing Questionnaire (Submitted)"
      style={{ marginTop: 12, borderRadius: 8 }}
      bodyStyle={{ paddingTop: 16 }}
    >
      {answerDoc.answer.map((a, idx) => (
        <div key={a?.uuid || idx} style={{ marginBottom: 14 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>
            {a?.question || `Question ${idx + 1}`}
          </div>
          <div style={{ whiteSpace: "pre-wrap", color: "#333" }}>
            {String(a?.answer ?? "")}
          </div>
        </div>
      ))}
    </Card>
  );
}
